import apiClient from '../api/api';
import { API_ENDPOINTS } from '../api/api.config';

export interface Template {
  _id: string;
  is_deleted?: boolean;
  schema_name: string;
  schema_description: string;
  output_schema_structure: any;
  createdAt: string;
  updatedAt: string;
}

export interface CreateTemplateData {
  schema_name: string;
  schema_description: string;
  output_schema_structure: any;
}

export interface UpdateTemplateData {
  schema_name?: string;
  schema_description?: string;
  output_schema_structure?: any;
}

export interface TemplateListParams {
  skip: number;
  limit: number;
  schema_name?: string;
}

export interface TemplateListResponse {
  success: boolean;
  code: number;
  data: {
    schemaConfigsList: Template[];
    total_count: number;
  };
}

export interface TemplateResponse {
  success: boolean;
  code: number;
  data: Template;
}

class TemplateService {
  async getTemplates(params: TemplateListParams): Promise<TemplateListResponse> {
    try {
      const response = await apiClient.post(API_ENDPOINTS.TEMPLATES.LIST, params);
      return response.data;
    } catch (error) {
      console.error('Error fetching templates:', error);
      throw error;
    }
  }

  async createTemplate(templateData: CreateTemplateData): Promise<Template> {
    try {
      const response = await apiClient.post(API_ENDPOINTS.TEMPLATES.CREATE, templateData);
      return response.data.data;
    } catch (error) {
      console.error('Error creating template:', error);
      throw error;
    }
  }

  async updateTemplate(id: string, templateData: UpdateTemplateData): Promise<Template> {
    try {
      const response = await apiClient.put(API_ENDPOINTS.TEMPLATES.UPDATE(id), templateData);
      return response.data.data;
    } catch (error) {
      console.error(`Error updating template ${id}:`, error);
      throw error;
    }
  }

  async deleteTemplate(id: string): Promise<void> {
    try {
      await apiClient.delete(API_ENDPOINTS.TEMPLATES.DELETE(id));
    } catch (error) {
      console.error(`Error deleting template ${id}:`, error);
      throw error;
    }
  }

  async getTemplateById(id: string): Promise<TemplateResponse> {
    try {
      const response = await apiClient.get(API_ENDPOINTS.TEMPLATES.GET_BY_ID(id));
       return response.data;
    } catch (error) {
      console.error(`Error deleting template ${id}:`, error);
      throw error;
    }
  }
}

export const templateService = new TemplateService();
export default templateService;
